/* eslint max-len: 0 */
import React, { FC } from 'react';
import { SvgComponentProps } from './types';
import { Svg } from './Svg';

const ModCandidatePension: FC<SvgComponentProps> = (props) => {
	return (
		<Svg {...props}>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M5.442 4.174C3.408 6.052 2 9.701 2 11.5C2 13.985 2 16 8 16C14 16 14 13.985 14 11.5C14 9.701 12.592 6.052 10.558 4.174C9.864 4.641 8.973 5 8 5C7.027 5 6.136 4.641 5.442 4.174ZM6.48 9C6.685 8.725 6.944 8.494 7.242 8.321C7.625 8.101 8.058 7.984 8.5 7.984C8.942 7.984 9.375 8.101 9.758 8.321L10.25 7.469C9.718 7.162 9.114 7 8.5 7C7.886 7 7.282 7.162 6.75 7.469C6.218 7.776 5.776 8.218 5.469 8.75C5.422 8.832 5.378 8.915 5.338 9H4.5L4 10H5.036C5.012 10.165 5 10.332 5 10.5C5 10.668 5.012 10.835 5.036 11H3.5L3 12H5.338C5.378 12.085 5.422 12.168 5.469 12.25C5.776 12.782 6.218 13.224 6.75 13.531C7.282 13.838 7.886 14 8.5 14C9.114 14 9.718 13.838 10.25 13.531L9.758 12.679C9.375 12.9 8.942 13.016 8.5 13.016C8.058 13.016 7.625 12.9 7.242 12.679C6.944 12.506 6.685 12.275 6.48 12H8.5L9 11H6.034C6.001 10.836 5.984 10.669 5.984 10.5C5.984 10.331 6.001 10.164 6.034 10H9.5L10 9H6.48ZM5.854 1.23C5.508 1.069 5 1.003 5 1.385C5 2.149 6.343 4 8 4C9.657 4 11 2.149 11 1.385C11 0.867 10.284 1.068 9.802 1.255C9.615 1.327 9.432 1.328 9.282 1.242C9.243 1.22 9.208 1.192 9.177 1.16C8.775 0.745 8.578 0 8 0C7.911 0 7.822 0.002 7.735 0.005C7.137 0.03 6.959 0.832 6.489 1.203C6.471 1.218 6.452 1.231 6.432 1.242C6.267 1.337 6.06 1.326 5.854 1.23Z'
			/>
		</Svg>
	);
};

export { ModCandidatePension };
